export const HTTP = {
    createProject: async function (baseUrl, mimeType) {
        const response = await fetch(`${baseUrl}/projects`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                mimeType,
            }),
        });
        if (response.status !== 201) {
            throw new Error(response.statusText);
        }
        const { sessionId, url } = (await response.json());
        return { sessionId, url };
    },
    listEvents: async function (baseUrl, sessionId) {
        const url = `${baseUrl}/projects/${sessionId}/events`;
        const response = await fetch(url);
        if (response.status !== 200) {
            throw new Error(response.statusText, { cause: url });
        }
        return (await response.json());
    },
    putFile: async function (url, file) {
        const response = await fetch(url, {
            method: "PUT",
            body: file,
        });
        if (response.status !== 200) {
            throw new Error(response.statusText);
        }
    },
    getProgress: async function (baseUrl, sessionId) {
        const url = `${baseUrl}/projects/${sessionId}/progress`;
        const response = await fetch(url);
        if (response.status !== 200) {
            throw new Error(response.statusText, { cause: url });
        }
        return (await response.json()).progress;
    },
    getResults: async function (baseUrl, sessionId) {
        const url = `${baseUrl}/projects/${sessionId}/results`;
        const response = await fetch(url);
        if (response.status !== 200) {
            throw new Error(response.statusText, { cause: url });
        }
        return response;
    },
};
//# sourceMappingURL=http.js.map